import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import classNames from 'classnames';
import ReviewStars from '$components/basic/ReviewStars';
import type { AppGarageReview } from '$page-router/api/getGaragesByLatLong';
import { Card } from '@/components/atoms/Card';
import { ReviewQuote } from './components/ReviewQuote';

import styles from './index.module.scss';

interface GarageReviewSectionProps extends AppGarageReview, ComponentPropsWithoutRef<'div'> {
  readonly translations: {
    readonly reviewTitle: string;
  };
}

export function GarageReviewSection({
  rating = 4,
  text,
  authorName,
  relativeTime,
  translations: { reviewTitle },
  className,
}: GarageReviewSectionProps): ReactNode {
  if (!text) return null;

  return (
    <div className={classNames(GarageReviewSection.displayName, styles.GarageReviewSection, className)}>
      <p className={classNames(styles.ReviewTitle, 'ReviewTitle')}>{reviewTitle}</p>
      <Card cornerRadius={1} className={styles.ReviewCard}>
        <ReviewStars
          className={classNames(styles.ReviewStars, 'ReviewStars')}
          stars={rating}
          starHeight={16}
          starWidth={16}
        />
        <ReviewQuote text={text} authorName={authorName} relativeTime={relativeTime} />
      </Card>
    </div>
  );
}

GarageReviewSection.displayName = 'GarageReviewSection';
